import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuickActions = ({ onAddVendor }) => {
  const navigate = useNavigate();

  const quickActionItems = [
    {
      title: "Add New Vendor",
      description: "Create a new vendor account",
      icon: "UserPlus",
      color: "primary",
      action: onAddVendor
    },
    // {
    //   title: "Manage Employees",
    //   description: "View and manage all employees",
    //   icon: "Users",
    //   color: "secondary",
    //   action: () => navigate('/employee-management')
    // },
    {
      title: "System Settings",
      description: "Configure system preferences",
      icon: "Settings",
      color: "accent",
      action: () => navigate('/user-profile-settings')
    },
    {
      title: "Export Reports",
      description: "Generate and download reports",
      icon: "Download",
      color: "success",
      action: () => console.log('Export reports')
    }
  ];

  const getColorClasses = (color) => {
    const colors = {
      primary: "bg-primary/10 text-primary hover:bg-primary/20",
      secondary: "bg-secondary/10 text-secondary hover:bg-secondary/20",
      accent: "bg-accent/10 text-accent hover:bg-accent/20",
      success: "bg-success/10 text-success hover:bg-success/20"
    };
    return colors[color] || colors.primary;
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="mb-6">
        <h2 className="text-lg font-semibold text-foreground">Quick Actions</h2>
        <p className="text-sm text-muted-foreground">Frequently used administrative tasks</p>
      </div>
      
      <div className="space-y-3">
        {quickActionItems.map((item, index) => (
          <button
            key={index}
            onClick={item.action}
            className={`w-full p-4 rounded-lg border border-border micro-animation ${getColorClasses(item.color)} text-left`}
          >
            <div className="flex items-center space-x-3">
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${getColorClasses(item.color)}`}>
                <Icon name={item.icon} size={20} />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-medium text-foreground">{item.title}</h3>
                <p className="text-sm text-muted-foreground truncate">{item.description}</p>
              </div>
              <Icon name="ChevronRight" size={16} className="text-muted-foreground" />
            </div>
          </button>
        ))}
      </div>
      
      <div className="mt-6 pt-6 border-t border-border">
        <Button
          variant="outline"
          fullWidth
          iconName="Plus"
          iconPosition="left"
          iconSize={16}
          onClick={onAddVendor}
        >
          Add New Vendor
        </Button>
      </div>
    </div>
  );
};

export default QuickActions;